function FormResettableCtrl($scope, $attrs, $parse) {
    'ngInject';

    $scope.inputs = [];

    $scope.resetForm = function (options) {
        if (options && options.clear_submitted) {
            $scope[$attrs.name].submitted = false;
        }
        return Array.from($scope.inputs).map(input =>
            (input.getter.assign($scope, null),
                input.controller.$setPristine()));
    };

    return {
        registerInput(input, ctrl) {
            const getter = $parse(input);
            return $scope.inputs.push({getter, controller: ctrl});
        }
    };
}

function formResettableDirective() {
    'ngInject';

    return {
        restrict: 'A',
        controller: FormResettableCtrl
    };
}

// Adds field clearing behaviour to forms.
angular
    .module('BB')
    .directive('bbFormResettable', formResettableDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/form-resettable/form_resettable.directive.js